<script>
    export default {
        name: "ProductOffersSize",
        props: {
            activeId: [Number, String],
            sizes: {
                type: Array,
                required: true,
            },
        },
        methods: {
            changeSize(id) {
                this.$emit("on-change", id);
            },
        },
    };
</script>

<template>
    <div class="product-offers-size">
        <div class="product-offers-size__title">Размер:</div>
        <div class="product-offers-size__list">
            <button
                v-for="size in sizes"
                :key="size.id"
                class="product-offers-size__item outline"
                :class="{ 'is-active': size.id === activeId }"
                @click="changeSize(size.id)"
            >
                {{ size.name }}
            </button>
        </div>
    </div>
</template>

<style lang="scss">
    .product-offers-size__list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -2px;
    }

    .product-offers-size__title {
        margin-bottom: 5px;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
    }

    .product-offers-size__item {
        min-width: 70px;
        margin: 0 2px;
        padding: var(--product-size-padding);
        color: var(--primary-text);
        font-size: 14px;
        line-height: 14px;
        border: var(--product-size-border);
        border-radius: var(--product-size-border-radius);
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            border-color: var(--product-size--hover-border);
            box-shadow: var(--product-size--hover-shadow);
        }

        &.is-active {
            color: var(--product-size--active-color);
            border-color: var(--product-size--active-color);
            box-shadow: var(--product-size--active-shadow);
            pointer-events: none;
        }
    }
</style>
